const servicesData = [
    {
        name : 'Floride Treatment',
        img : 'https://imgur.com/jASEb0l.png',
        description : 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto, rerum? Aspernatur, ut ipsam! Provident, quod molestias illum optio cumque  ! '
    },
    {
        name : 'Cavity Filling',
        img : 'https://imgur.com/NJhXMx5.png',
        description : 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto, rerum? Aspernatur, ut ipsam! Provident, quod molestias illum optio cumque  ! '
    },
    {
        name : 'Teeth Whitening',
        img : 'https://imgur.com/L3meLFc.png',
        description : 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto, rerum? Aspernatur, ut ipsam! Provident, quod molestias illum optio cumque  ! '
    },
]

export default servicesData;